/**
 * Shared media URL helpers for the Feed components.
 * All BunnyCDN URLs are routed through the backend proxy to handle Token Auth.
 */
import ENV from "config/environment";

const getBaseUrl = () => ENV.API_BASE_URL.replace(/\/api$/, '');

export const getAvatarUrl = (img) => {
  if (!img) return null;
  let url = typeof img === 'string' ? img : img.url;
  if (!url) return null;
  const baseUrl = getBaseUrl();
  if (url.includes('b-cdn.net')) return `${baseUrl}/api/media/secure?url=${encodeURIComponent(url)}`;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${baseUrl}/${url.replace(/^\//, '')}`;
};

export const getMediaUrl = (url) => {
  if (!url) return null;
  const baseUrl = getBaseUrl();
  if (url.includes('b-cdn.net')) return `${baseUrl}/api/media/secure?url=${encodeURIComponent(url)}`;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${baseUrl}/${url.replace(/^\//, '')}`;
};
